import React from 'react'
import { useHistory } from 'react-router-dom'
import { ViewGridIcon, ChevronDownIcon } from '@heroicons/react/outline'
import { useTranslation } from 'react-i18next'

export default function WarehouseSelector({ warehouse, isCollapsed }) {
    const history = useHistory()
    const { t } = useTranslation()
    const warehouseName = warehouse?.name || warehouse?.id || '—'

    const handleClick = () => history.push('/')

    if (isCollapsed) {
        return (
            <div className="py-2.5 flex justify-center border-b" style={{ borderColor: '#ebebeb' }}>
                <button
                    onClick={handleClick}
                    title={warehouseName}
                    className="w-10 h-10 flex items-center justify-center rounded-lg bg-gray-100 hover:bg-gray-200"
                >
                    <ViewGridIcon className="w-5 h-5" style={{ color: '#DCA118' }} />
                </button>
            </div>
        )
    }

    return (
        <div className="px-4 py-2.5 border-b" style={{ borderColor: '#ebebeb' }}>
            <button
                onClick={handleClick}
                className="w-full flex items-center gap-2 bg-gray-100 hover:bg-gray-200 rounded-lg px-3 py-2.5 text-left"
            >
                <ViewGridIcon className="w-4 h-4 flex-shrink-0" style={{ color: '#DCA118' }} />
                <div className="flex-1 min-w-0">
                    <div className="text-sm font-semibold text-gray-900 truncate">{warehouseName}</div>
                    <div className="text-xs text-gray-400">{t('sidebar.cambiar_almacen', 'Cambiar almacén')}</div>
                </div>
                <ChevronDownIcon className="w-3.5 h-3.5 flex-shrink-0" style={{ color: '#DCA118' }} />
            </button>
        </div>
    )
}
